import React from 'react';
import { getPaginationItems } from '../general/PaginationBar';

function ReportPaginationFooter({
    totalRegistros,
    indicePrimerRegistro,
    indiceUltimoRegistro,
    paginaActual,
    cambiarPagina,
    totalPaginas,
    registrosPorPagina,
    onPageSizeChange,
    itemLabel = 'registros',
}) {
    if (totalRegistros === 0) return null;

    return (
        <div
            className="d-flex justify-content-between align-items-center flex-wrap px-3 py-3 bg-white"
            style={{ gap: '12px', borderTop: '1px solid #eef2f6' }}
        >
            <div className="d-flex align-items-center flex-wrap" style={{ gap: '10px' }}>
                <span className="text-muted" style={{ fontSize: '0.86rem' }}>
                    Mostrando <strong>{indicePrimerRegistro + 1}</strong> a{' '}
                    <strong>{indiceUltimoRegistro}</strong> de <strong>{totalRegistros}</strong> {itemLabel}
                </span>
                <label className="mb-0 d-flex align-items-center text-muted" style={{ fontSize: '0.86rem', gap: '6px' }}>
                    Filas por página:
                    <select
                        className="form-control form-control-sm"
                        style={{ width: 'auto', minWidth: '88px' }}
                        value={registrosPorPagina}
                        onChange={onPageSizeChange}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value="all">Todos</option>
                    </select>
                </label>
            </div>

            {registrosPorPagina !== 'all' && totalPaginas > 1 && (
                <nav>
                    <ul className="pagination pagination-sm mb-0 smile-pagination">
                        <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                            <button
                                type="button"
                                className="page-link smile-pagination-btn"
                                onClick={() => cambiarPagina(paginaActual - 1)}
                                disabled={paginaActual === 1}
                            >
                                ‹
                            </button>
                        </li>
                        {getPaginationItems(paginaActual, totalPaginas).map((item, idx) => {
                            if (item === '...') {
                                return (
                                    <li key={`ellipsis-${idx}`} className="page-item disabled">
                                        <span className="page-link smile-pagination-ellipsis">...</span>
                                    </li>
                                );
                            }
                            const activa = paginaActual === item;
                            return (
                                <li key={item} className={`page-item ${activa ? 'active' : ''}`}>
                                    <button
                                        type="button"
                                        className={`page-link smile-pagination-btn${activa ? ' smile-pagination-btn--active' : ''}`}
                                        onClick={() => cambiarPagina(item)}
                                    >
                                        {item}
                                    </button>
                                </li>
                            );
                        })}
                        <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                            <button
                                type="button"
                                className="page-link smile-pagination-btn"
                                onClick={() => cambiarPagina(paginaActual + 1)}
                                disabled={paginaActual === totalPaginas}
                            >
                                ›
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
}

export default ReportPaginationFooter;
